import { Box, Stack, Typography, Divider } from '@mui/material'
import { CollapsibleSection } from 'components/CollapsibleSection'
import { useTranslation } from 'react-i18next'
import { useMySubmissionsQuery } from 'services/submissions'
import { ILot } from 'types/lots'
import { ProcurementSubmission } from './procurement-submission'
import { RequiredDocsSubmission } from './required-docs-submission'
import { TechnicalSubmission } from './technical-submission'
import { Loading } from 'components/Loading'
import { ITender } from 'types/tender'
import { useTenderPassedDocDeadline } from 'hooks/date/useTenderPassedDocDeadline';


type Props = {
  lot: ILot
  tender: ITender
}

export const OfferCreation = ({ lot, tender }: Props) => {
  const { t } = useTranslation()

  const { data: submission, isLoading } = useMySubmissionsQuery(
    { lotId: lot.id },
    { skip: !lot }
  )
  const hasDocDeadlinePassed = useTenderPassedDocDeadline(tender)


  if (isLoading) {
    return <Loading fullPage={false} />
  }

  if (submission === undefined) {
    return null
  }

  const hasDocumentRequirements =
    !!lot.documentRequirements?.[0]?.documentRequirementItems?.length
    || !!lot.documentRequirements?.[1]?.documentRequirementItems?.length

  return (
    <>
      <Box sx={{ backgroundColor: '#999', padding: 2 }}>
        <Typography textAlign="center" color="white" variant="body2">
          {t('createOfferInformation')}
        </Typography>
      </Box>
      <CollapsibleSection title={t('offerCreation')} variant="secondary">
        <Stack spacing={5}>
          {hasDocumentRequirements && (
            <Stack spacing={1}>
              <Stack>
                <Typography fontWeight="bold">{t('required-docs')}</Typography>
                <Divider />
              </Stack>
              <RequiredDocsSubmission
                submission={submission}
                documentRequirements={lot.documentRequirements}
                hasDocDeadlinePassed={hasDocDeadlinePassed}
              />
            </Stack>
          )}
          <Stack spacing={1}>
            <Stack>
              <Typography fontWeight="bold">{t('tender-proposal')}</Typography>
              <Divider />
            </Stack>
            <ProcurementSubmission
              procurementRequirement={lot.procurementRequirement}
              submission={submission}
              lotId={lot.id}
              hasDocDeadlinePassed={hasDocDeadlinePassed}
            />
            <TechnicalSubmission
              technicalRequirement={lot.technicalRequirement}
              submission={submission}
              hasDocDeadlinePassed={hasDocDeadlinePassed}
            />
          </Stack>
        </Stack>
      </CollapsibleSection>
    </>
  )
}
